import React, { useEffect, useState,  } from 'react'
import { Container, Row, Col, Button, Modal, Form, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import Select from "react-select"
import { addMenu, getMenus } from '../../../../actions/menusActions'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import { getProducts } from '../../../../actions/productsActions'

export default function Menus() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

	const {menus, resultmenu, loading} = useSelector(state=>state.menus)
	const {products, total} = useSelector(state=>state.products)

    const [firstdishesTextIcons, setFirstdishesTextIcons] = useState([])
    const [seconddishesTextIcons, setSeconddishesTextIcons] = useState([])
    const [dessertsTextIcons, setDessertsTextIcons] = useState([])
    // const [drinksTextIcons, setDrinksTextIcons] = useState([])
    // const [complementsTextIcons, setComplementsTextIcons] = useState([])

    const [modalShow, setModalShow] = useState(false)
    const [newMenu, setNewMenu] = useState({})

    const [isRegistering, setIsRegistering] = useState(false)

	useEffect(() => {
		if(client){
            dispatch({type: 'CALENDAR_RESET'})
			dispatch(getMenus(page, limit, search))
			dispatch(getProducts())
		}
	},[dispatch, t, client])

    useEffect(() => {
        if (client) {
            dispatch(getMenus(page, limit, search))
        }
    }, [page, limit, search])

    useEffect(()=>{
        if (menus) {
        }
        if (products) {
            let firstdishesArray = []
            let seconddishesArray = []
            // let drinksArray = []
            let dessertArray = []
            // let complementsArray = []

            products?.forEach(product => {
                let object
                if(product?.type === 'Dish'){
                    if(product?.photo){
                        object = {value: product?._id, label: <div><img src={product?.photo} alt={product?.name} height="30px" width="30px"/> {product?.name}</div>}
                    }else{
                        object = {value: product?._id, label: <div>{product?.name}</div>}
                    }
                    firstdishesArray.push(object)
                    seconddishesArray.push(object)
                    // if(product.isComplement){
                    //     complementsArray.push(object)
                    // }
                }
                // if(product.type === 'Drink'){
                //     if(product.photo){
                //         object = {value: product._id, label: <div><img src={product.photo} alt={product.name} height="30px" width="30px"/> {product.name}</div>}
                //     }else{
                //         object = {value: product._id, label: <div>{product.name}</div>}
                //     }
                //     drinksArray.push(object)
                //     if(product.isComplement){
                //         complementsArray.push(object)
                //     }
                // }
                if(product?.type === 'Dessert'){
                    if(product?.photo){
                        object = {value: product?._id, label: <div><img src={product?.photo} alt={product?.name} height="30px" width="30px"/> {product?.name}</div>}
                    }else{
                        object = {value: product?._id, label: <div>{product?.name}</div>}
                    }
                    dessertArray.push(object)
                    // if(product.isComplement){
                    //     complementsArray.push(object)
                    // }
                }
            })
            setFirstdishesTextIcons({options: firstdishesArray, selected: null})
            setSeconddishesTextIcons({options: seconddishesArray, selected: null})
            // setDrinksTextIcons({options: drinksArray, selected: null})
            setDessertsTextIcons({options: dessertArray, selected: null})
            // setComplementsTextIcons({options: complementsArray, selected: null})
        }
    }, [menus, products, client, dispatch])

    const openModal = () =>{
        setNewMenu({
            name: '',
            price: 0,
            firstdishes: [],
            seconddishes: [],
            desserts: [],
            drinks: [],
            complements: [],
        })
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setNewMenu({
            ...newMenu,
            [target.name]: target.value
        })
    }

    const handleSelectChange = async(typeproduct, arrayProducts) => {
        setNewMenu({
            ...newMenu,
            [typeproduct]: arrayProducts
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        let arrayFirstdishes = newMenu?.firstdishes?.map(firstdish => {
            return firstdish.value
        })
        let arraySeconddishes = newMenu?.seconddishes?.map(seconddish => {
            return seconddish.value
        })
        let arrayDesserts = newMenu?.desserts?.map(dessert => {
            return dessert.value
        })
        let arrayDrinks = newMenu?.drinks?.map(drink => {
            return drink.value
        })
        let arrayComplements = newMenu?.complements?.map(complement => {
            return complement.value
        })

        dispatch(addMenu({
            ...newMenu,
            firstdishes: arrayFirstdishes,
            seconddishes: arraySeconddishes,
            desserts: arrayDesserts,
            drinks: arrayDrinks,
            complements: arrayComplements
        }))
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultmenu){
            switch (resultmenu) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.menus.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                case 'menuduplicated':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.menus.menuduplicated')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultmenu])

	const columnsMenus = [
		{
			name: t('admin.menus.name'),
			cell: menu =>
				<div>
					{menu.name}
				</div>,
			selector: (menu) => menu.name,
			sortable: true,
		},{
			name: t('admin.menus.dishes'),
			cell: menu =>
				<div>
					{t('admin.menus.firstdishes')}: {menu.firstdishes?.length}<br/>
                    {t('admin.menus.seconddishes')}: {menu.seconddishes?.length}<br/>
                    {t('admin.menus.desserts')}: {menu.desserts?.length}
				</div>,
			selector: (menu) => menu.type,
			sortable: true,
		},{
			name: t('admin.menus.price'),
			cell: menu =>
				<div>
					{menu.price}
				</div>,
			selector: (menu) => menu.price,
			sortable: true,
		},{
			name: '',
			cell: menu =>
				<div>
					<Link to={`/admin/menus/${menu._id}`}>
						{t('admin.menus.edit')}
					</Link>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/menusdashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.menus.menus')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Button variant='primary' type="submit" className="btn-primary my-2 button-withicon" onClick={() => openModal()}>
                    <label className='label-button'>{t('admin.menus.createmenu')}</label>
                </Button>
            </Row>
            <Row className="mt-5 ">
                <label className='sd-label-medium'>{t('admin.menus.listmenus')}</label>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex my-2">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder={t("datatables.buscar")}
                            value={searchAux || ""}
                            onChange={e => {
                                setSearchAux(e.target.value);
                                setPage(1);
                            }}
                            onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                        />
                        <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                    </div>
                    {loading ?
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    :
                        menus?.length > 0 ?
                            <CustomDataTable
                                columns={columnsMenus}
                                data={menus}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                searchable={'custom'}
                                searchText={search}
                                onChangeRowsPerPage={(newLimit) => {
                                    setLimit(newLimit)
                                    setPage(1)
                                }}
                                onChangePage={(newPage) => {
                                    setPage(newPage)
                                }}
                            />
                        :
                            <h4 className='mt-4'>{t('admin.menus.thereisnotmenus')}</h4>
                    }

                </Col>
            </Row>
            <Modal show={modalShow} className="sd-modal" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center'>
                        <label className='sd-label-create'>{t('admin.menus.createmenu')}</label>
                    </div>
                    <Form className="px-4 formulario" onSubmit={handleAdd}>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.namemenu')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='name'
                                value={newMenu.name ||  ''}
                                placeholder={t('admin.menus.setname')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.price')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='price'
                                value={newMenu.price ||  ''}
                                placeholder={t('admin.menus.price')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.firstdishesmenu')}</h2>
                            <Select
                                className="text-start p-0"
                                isMulti
                                name={'firstdishes'}
                                options={firstdishesTextIcons?.options}
                                value={newMenu?.firstdishes}
                                // Usamos getOptionLabel solo para la búsqueda por texto
                                getOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;

                                    // If labelChildren is an array, filter the strings
                                    if (Array.isArray(labelChildren)) {
                                        const labelText = labelChildren.filter(child => typeof child === 'string');
                                        return labelText.join('');
                                    }

                                    // If labelChildren is not an array (likely a string), return it directly
                                    if (typeof labelChildren === 'string') {
                                        return labelChildren;
                                    }

                                    // Fallback in case none of the above conditions are met
                                    return option.label;
                                }}
                                // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                                formatOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;
                                    const hasPhoto = Array.isArray(labelChildren);
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {hasPhoto && (
                                                <img
                                                    src={labelChildren[0]?.props?.src}
                                                    alt={labelChildren[0]?.props?.alt}
                                                    style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                                />
                                            )}
                                            <span>{hasPhoto ? labelChildren[2] : labelChildren}</span>
                                        </div>
                                    );
                                }}
                                onChange={(e) => handleSelectChange('firstdishes', e)}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.seconddishesmenu')}</h2>
                            <Select
                                className="text-start p-0"
                                isMulti
                                name={'seconddishes'}
                                options={seconddishesTextIcons.options}
                                value={newMenu?.seconddishes}
                                // Usamos getOptionLabel solo para la búsqueda por texto
                                getOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;

                                    // If labelChildren is an array, filter the strings
                                    if (Array.isArray(labelChildren)) {
                                        const labelText = labelChildren.filter(child => typeof child === 'string');
                                        return labelText.join('');
                                    }

                                    // If labelChildren is not an array (likely a string), return it directly
                                    if (typeof labelChildren === 'string') {
                                        return labelChildren;
                                    }

                                    // Fallback in case none of the above conditions are met
                                    return option.label;
                                }}
                                // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                                formatOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;
                                    const hasPhoto = Array.isArray(labelChildren);
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {hasPhoto && (
                                                <img
                                                    src={labelChildren[0]?.props?.src}
                                                    alt={labelChildren[0]?.props?.alt}
                                                    style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                                />
                                            )}
                                            <span>{hasPhoto ? labelChildren[2] : labelChildren}</span>
                                        </div>
                                    );
                                }}
                                onChange={(e) => handleSelectChange('seconddishes', e)}
                                required
                            />
                        </Row>
                        {/* <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.drinks')}</h2>
                            <Select
                                className="text-start p-0"
                                isMulti
                                name={'drinks'}
                                options={drinksTextIcons.options}
                                value={newMenu?.drinks}
                                onChange={(e) => handleSelectChange('drinks', e)}
                                required
                            />
                        </Row> */}
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.desserts')}</h2>
                            <Select
                                className="text-start p-0"
                                isMulti
                                name={'desserts'}
                                options={dessertsTextIcons.options}
                                value={newMenu?.desserts}
                                // Usamos getOptionLabel solo para la búsqueda por texto
                                getOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;

                                    // If labelChildren is an array, filter the strings
                                    if (Array.isArray(labelChildren)) {
                                        const labelText = labelChildren.filter(child => typeof child === 'string');
                                        return labelText.join('');
                                    }

                                    // If labelChildren is not an array (likely a string), return it directly
                                    if (typeof labelChildren === 'string') {
                                        return labelChildren;
                                    }

                                    // Fallback in case none of the above conditions are met
                                    return option.label;
                                }}
                                // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                                formatOptionLabel={(option) => {
                                    const labelChildren = option?.label?.props?.children;
                                    const hasPhoto = Array.isArray(labelChildren);
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {hasPhoto && (
                                                <img
                                                    src={labelChildren[0]?.props?.src}
                                                    alt={labelChildren[0]?.props?.alt}
                                                    style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                                />
                                            )}
                                            <span>{hasPhoto ? labelChildren[2] : labelChildren}</span>
                                        </div>
                                    );
                                }}
                                onChange={(e) => handleSelectChange('desserts', e)}
                                required
                            />
                        </Row>
                        {/*
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.complements')}</h2>
                            <Select
                                className="text-start p-0"
                                isMulti
                                name={'complements'}
                                options={complementsTextIcons.options}
                                value={newMenu?.complements}
                                onChange={(e) => handleSelectChange('complements', e)}
                                required
                            />
                        </Row> */}
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {isRegistering
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('admin.menus.register')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
	)
}